module.exports = __webpack_public_path__ + "img/speedometer-medium.9cca76db.svg";